import React from 'react'

const Python_Cloud = () => {
  return (
    <div>
        {/* collapseFourtyThree */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFourtyThree">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourtyThree" aria-expanded="false" aria-controls="collapseFourtyThree">
                    Python
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFourtyThree" className="accordion-collapse collapse" aria-labelledby="headingFourtyThree" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Introduction to Python</li>
                        <li>Installation</li>
                        <li>Variables, Data Types</li>
                        <li>Strings, Numbers</li>
                        <li>List, Arrays</li>
                        <li>Tuples</li>
                        <li>Dictionary</li>
                        <li>Set</li>
                        <li>Control Flow - Decision Making, Looping, Branching</li>
                        <li>Functions</li>
                        <li>OOPs Concepts</li>
                        <li>Classes & Objects</li>
                        <li>File Handling</li>
                        <li>Exception Handling</li>
                        <li>Web Frameworks - Django & Flask</li>
                        <li>API Handling</li>
                        <li>Scripting</li>
                        <li>Advanced Libraries</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Python_Cloud